import {
    CubeIcon,
    DocumentIcon,
    PaperClipIcon,
    PhotoIcon,
    Square3Stack3DIcon,
    VideoCameraIcon
} from '@heroicons/react/24/outline';
import React from 'react';

/** Above this many files, bulk (ZIP) downloads ask for confirmation first. */
export const MAX_BULK_FILES_WARNING = 30;

// Stacked-slices icon for CBCT (a volumetric scan), distinct from the plain
// cube used for 3D Models (STL) so the two read apart at a glance.
export const CATEGORY_ICONS: Record<string, React.ReactNode> = {
    Images: <PhotoIcon className="w-4 h-4" />,
    Videos: <VideoCameraIcon className="w-4 h-4" />,
    Documents: <DocumentIcon className="w-4 h-4" />,
    '3D Models': <CubeIcon className="w-4 h-4" />,
    CBCT: <Square3Stack3DIcon className="w-4 h-4" />,
    Others: <PaperClipIcon className="w-4 h-4" />
};

export const CATEGORY_ICONS_LARGE: Record<string, React.ReactNode> = {
    Images: <PhotoIcon className="w-8 h-8 text-gray-400" />,
    Videos: <VideoCameraIcon className="w-8 h-8 text-gray-400" />,
    Documents: <DocumentIcon className="w-8 h-8 text-gray-400" />,
    '3D Models': <CubeIcon className="w-8 h-8 text-gray-400" />,
    CBCT: <Square3Stack3DIcon className="w-8 h-8 text-gray-400" />,
    Others: <PaperClipIcon className="w-8 h-8 text-gray-400" />
};
